export default __webpack_public_path__ + "static/media/youtubeicon.ebe41200.svg";